/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitReview_unfreezeAndResetCreditPullRetries_Status = { readonly __typename: 'Status', readonly message: string | null };

export type SubmitReview_Mutation = { readonly __typename: 'Mutation', readonly unfreezeAndResetCreditPullRetries: SubmitReview_unfreezeAndResetCreditPullRetries_Status | null };


export type SubmitReviewVariables = _Types.Exact<{
  companyDivvyUuid: _Types.Scalars['String']['input'];
  salesforceCreditId: _Types.Scalars['String']['input'];
}>;


export type SubmitReview = SubmitReview_Mutation;


export const SubmitReviewDocument = gql`
    mutation SubmitReview($companyDivvyUuid: String!, $salesforceCreditId: String!) {
  unfreezeAndResetCreditPullRetries(
    companyDivvyUuid: $companyDivvyUuid
    salesforceCreditId: $salesforceCreditId
  ) {
    message
  }
}
    `;
export type SubmitReviewMutationFn = Apollo.MutationFunction<SubmitReview, SubmitReviewVariables>;

/**
 * __useSubmitReview__
 *
 * To run a mutation, you first call `useSubmitReview` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReview` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReview, { data, loading, error }] = useSubmitReview({
 *   variables: {
 *      companyDivvyUuid: // value for 'companyDivvyUuid'
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useSubmitReview(baseOptions?: Apollo.MutationHookOptions<SubmitReview, SubmitReviewVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitReview, SubmitReviewVariables>(SubmitReviewDocument, options);
      }
export type SubmitReviewHookResult = ReturnType<typeof useSubmitReview>;
export type SubmitReviewMutationResult = Apollo.MutationResult<SubmitReview>;
export type SubmitReviewMutationOptions = Apollo.BaseMutationOptions<SubmitReview, SubmitReviewVariables>;